export const WEBLOGIN_DOMAIN = 'app/modules/Weblogin/WEBLOGIN_DOMAIN';
export const WEBLOGIN_FETCH_VEHICLES = 'app/modules/Weblogin/WEBLOGIN_FETCH_VEHICLES';
export const WEBLOGIN_FETCH_VEHICLE = 'app/modules/Weblogin/WEBLOGIN_FETCH_VEHICLE';
export const WEBLOGIN_FETCH_VEHICLE_BUYING_CONTACT = 'app/modules/Weblogin/WEBLOGIN_FETCH_VEHICLE_BUYING_CONTACT';
export const WEBLOGIN_FETCH_VEHICLE_INVOICES = 'app/modules/Weblogin/WEBLOGIN_FETCH_VEHICLE_INVOICES';
export const WEBLOGIN_FETCH_VEHICLE_INVOICE = 'app/modules/Weblogin/WEBLOGIN_FETCH_VEHICLE_INVOICE';
export const WEBLOGIN_REQUSET_ADD_DOCUMENT = 'app/modules/Weblogin/WEBLOGIN_REQUSET_ADD_DOCUMENT';
